export default "/_next/static/audios/03b2b576c717394705349725d47a1852.mp3";